var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "card has-background-dark has-text-light",
      style: _vm.visible ? "display: block" : "display: none",
      attrs: { id: "search-results" }
    },
    [
      _c("div", { staticClass: "card-content" }, [
        _c(
          "div",
          { staticClass: "content list is-hoverable has-background-dark" },
          _vm._l(_vm.results, function(row, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "list-item has-text-white has-background-dark",
                on: {
                  click: function($event) {
                    return _vm.open(row)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(index + 1) +
                    ". " +
                    _vm._s(
                      row[
                        _vm.$conf.search[_vm.$store.getters["searchIndex"]].id
                      ]
                    ) +
                    "\n        "
                ),
                _c("b-icon", {
                  attrs: { icon: "arrow-right", type: "is-white" }
                })
              ],
              1
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }